import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "input-group-prepend"
}
const _hoisted_3 = { class: "input-group-text" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "input-group-append"
}
const _hoisted_6 = { class: "input-group-text" }

import { useField } from "vee-validate";
import { Options } from "@/types/components";
import { SelectContext } from "element-plus";
import { computed, ref, useSlots } from "vue";
export type SelectProps = {
	label?: string;
	labelClasses?: string;
	required?: boolean;
	errorMessage?: string;
	hasIcon?: boolean;
	alternative?: boolean;
	inputGroupClasses?: { [k: string]: string } | string;
	inputClasses?: { [k: string]: string } | string;
	formGroupClasses?: { [k: string]: string } | string;
	group?: string;
	addonLeftIcon?: string;
	addonRightIcon?: string;
	name: string;
	placeholder: string;
	disabled?: boolean;
	value: unknown;
	remote?: boolean;
	loading?: boolean;
	remoteMethod?: (query: string) => void;
	selectOptions: Pick<SelectContext, "props">["props"] & {
		size?: "large" | "default" | "small";
		valueKey?: string;
		noDataText?: string;
		options: Options[];
		multiple: boolean;
	};
};
// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    label: null,
    labelClasses: null,
    required: { type: Boolean },
    errorMessage: null,
    hasIcon: { type: Boolean },
    alternative: { type: Boolean },
    inputGroupClasses: null,
    inputClasses: null,
    formGroupClasses: null,
    group: null,
    addonLeftIcon: null,
    addonRightIcon: null,
    name: null,
    placeholder: null,
    disabled: { type: Boolean },
    value: null,
    remote: { type: Boolean },
    loading: { type: Boolean },
    remoteMethod: null,
    selectOptions: null
  },
  setup(__props: any) {

const props = __props as {
	label?: string;
	labelClasses?: string;
	required?: boolean;
	errorMessage?: string;
	hasIcon?: boolean;
	alternative?: boolean;
	inputGroupClasses?: { [k: string]: string } | string;
	inputClasses?: { [k: string]: string } | string;
	formGroupClasses?: { [k: string]: string } | string;
	group?: string;
	addonLeftIcon?: string;
	addonRightIcon?: string;
	name: string;
	placeholder: string;
	disabled?: boolean;
	value: unknown;
	remote?: boolean;
	loading?: boolean;
	remoteMethod?: (query: string) => void;
	selectOptions: Pick<SelectContext, "props">["props"] & {
		size?: "large" | "default" | "small";
		valueKey?: string;
		noDataText?: string;
		options: Options[];
		multiple: boolean;
	};
}



// State data
const focused = ref(false);
const model = ref<string>();

// hooks
const {
	value: inputValue,
	errorMessage,
	handleChange,
} = useField(props.name, undefined, {
	initialValue: props.value,
});
const slots = useSlots();

const hasIcon = computed(() => {
	const { addonRight, addonLeft } = slots;
	return (
		addonRight !== undefined ||
		addonLeft !== undefined ||
		props.addonRightIcon !== undefined ||
		props.addonLeftIcon !== undefined ||
		props.group
	);
});
const change = (a: string | string[]) => {
	return Array.isArray(a) ? handleChange(a.join(",")) : handleChange(a);
};

return (_ctx: any,_cache: any) => {
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-group", [__props.formGroupClasses]])
  }, [
    _renderSlot(_ctx.$slots, "label", {}, () => [
      (__props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: _normalizeClass(__props.labelClasses)
          }, [
            _createTextVNode(_toDisplayString(__props.label) + " ", 1),
            (__props.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
				{
					'has-danger': !!_unref(errorMessage),
					'input-group': _unref(hasIcon),
					'input-group-alternative': __props.alternative,
					focused: focused.value,
					'has-label': __props.label || _ctx.$slots.label,
				},
				__props.inputGroupClasses,
			])
    }, [
      (__props.addonLeftIcon || _ctx.$slots.addonLeft)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _renderSlot(_ctx.$slots, "addonLeft", {}, () => [
                _createElementVNode("i", {
                  class: _normalizeClass(__props.addonLeftIcon)
                }, null, 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "hidden",
        name: "agent",
        id: "agent",
        value: _unref(inputValue)
      }, null, 8, _hoisted_4),
      _createVNode(_component_el_select, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
        options: __props.selectOptions.options,
        "value-key": __props.selectOptions.valueKey,
        placeholder: __props.placeholder,
        size: __props.selectOptions.size,
        class: "form-control",
        "no-data-text": __props.selectOptions.noDataText,
        loading: __props.loading,
        filterable: "",
        remote: "",
        "remote-method": __props.remoteMethod,
        multiple: __props.selectOptions.multiple,
        onChange: change
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {
            options: __props.selectOptions.options
          })
        ]),
        _: 3
      }, 8, ["modelValue", "options", "value-key", "placeholder", "size", "no-data-text", "loading", "remote-method", "multiple"]),
      (__props.addonRightIcon || _ctx.$slots.addonRight)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _renderSlot(_ctx.$slots, "addonRight", {}, () => [
                _createElementVNode("i", {
                  class: _normalizeClass(__props.addonRightIcon)
                }, null, 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _renderSlot(_ctx.$slots, "infoBlock"),
    _renderSlot(_ctx.$slots, "helpBlock", {}, () => [
      _withDirectives(_createElementVNode("small", {
        class: _normalizeClass(["text-danger invalid-feedback", { 'mt-2': _unref(hasIcon) }]),
        style: {"display":"block"}
      }, _toDisplayString(_unref(errorMessage)), 3), [
        [_vShow, _unref(errorMessage)]
      ])
    ])
  ], 2))
}
}

})